<div class="container">

  <div
    class="dialog-content"
    *ngIf="product() as product"
  >

    <!-- =====================================================
         PRODUCT IMAGE
         ===================================================== -->

    <div class="product-image">

      <div
        class="image-frame"
        [class.out-of-stock-image]="isOutOfStock"
      >

        <img
          [src]="getImageUrl(product.imageUrl)"
          [alt]="getProductName()"
        />

        <!-- OUT OF STOCK OVERLAY -->

        <div
          class="out-of-stock-overlay"
          *ngIf="isOutOfStock"
        >

          <span>
            {{ 'PRODUCT.OUT_OF_STOCK' | translate }}
          </span>

        </div>

      </div>


      <!-- CATEGORY -->

      <div class="image-label">

        <span>
          ✦
        </span>

        {{ getCategoryName() }}

      </div>


      <!-- DISCOUNT -->

      <div
        class="discount-badge"
        *ngIf="hasDiscount && !isOutOfStock"
      >

        -{{ product.discountPercentage }}%

      </div>


      <!-- STOCK -->

      <div
        class="stock-badge"
        *ngIf="isOutOfStock"
      >

        {{ 'PRODUCT.OUT_OF_STOCK' | translate }}

      </div>

    </div>



    <!-- =====================================================
         PRODUCT DETAILS
         ===================================================== -->

    <div class="product-details">

      <!-- ===================================================
           HEADER
           =================================================== -->

      <div class="product-data">

<div>
  <span class="product-brand">

          {{ getBrandName() }}

        </span>

        <h2 class="product-name">

          {{ getProductName() }}

        </h2>
</div>
<div >

          <span class="price">

            {{ newPrice | number:'1.0-2' }}
{{ 'COMMON.EGP' | translate }}

          </span>

          <h5 class="old-price" *ngIf="hasDiscount">

            {{ oldPrice | number:'1.0-2' }}  {{ 'COMMON.EGP' | translate }}

         

          </h5>

         

       

      
</div>
      

       


        <!-- <div class="title-line"></div> -->

      </div>



      <!-- ===================================================
           DESCRIPTION
           =================================================== -->

<div
  class="product-description"
  *ngIf="getProductDescription()"
>

  <!-- HEADER -->

  <button
    type="button"
    class="description-header"
    (click)="descriptionExpanded = !descriptionExpanded"
  >

    <span class="description-title">
      {{ 'PRODUCT.DESCRIPTION' | translate }}
    </span>

    <mat-icon>
      {{
        descriptionExpanded
          ? 'keyboard_arrow_up'
          : 'keyboard_arrow_down'
      }}
    </mat-icon>

  </button>


  <!-- CONTENT -->

  <div
    class="description-content"
    *ngIf="descriptionExpanded"
  >

    <p >
      {{ getProductDescription() }}
    </p>

  </div>

</div>

      <!-- ===================================================
           OFFER
           =================================================== -->

      <div
        class="offer-box"
        *ngIf="hasDiscount"
      >

        <div class="offer-icon">
          %
        </div>


        <div class="offer-content">

          <span class="offer-title">

            {{ 'PRODUCT.SPECIAL_OFFER' | translate }}

          </span>


          <span class="offer-text">

            {{ product.discountPercentage }}% OFF

          </span>

        </div>

      </div>



     



      <!-- ===================================================
           OUT OF STOCK
           =================================================== -->

      <div
        class="out-of-stock-message"
        *ngIf="isOutOfStock"
      >

        <mat-icon>
          inventory_2
        </mat-icon>

        <span>

          {{ 'PRODUCT.PRODUCT_OUT' | translate }}

        </span>

      </div>



      <!-- ===================================================
           QUANTITY
           =================================================== -->

      <div
        class="product-description"
        *ngIf="!isOutOfStock"
      >

      <!--   <label for="quantity">

          {{ 'PRODUCT.QUANTITY' | translate }}

        </label> -->


        <div class="quantity-control">

          <button
            type="button"
            class="quantity-btn"
            (click)="setQuantity(quantity() - 1)"
            [disabled]="quantity() <= 1"
          >

            −

          </button>


          <input
            id="quantity"
            type="number"
            [ngModel]="quantity()"
            (ngModelChange)="setQuantity($event)"
            [ngModelOptions]="{ standalone: true }"
            min="1"
            [max]="stock || null"
            step="1"
            class="quantity-input"
            aria-label="Quantity"
          />


          <button
            type="button"
            class="quantity-btn"
            (click)="setQuantity(quantity() + 1)"
          >

            +

          </button>

        </div>

      </div>
<!--=============================================
category and sub category
==========================================-->
 <div class="product-description">

   <span class="description-title">
      {{ 'PRODUCT.CATEGORY' | translate }}
    </span>
          <div class="category-name">

            {{ getCategoryName() }}

          </div>


        

        </div>
<div class="product-description">
  <ng-container
            *ngIf="product.subCategories.length"
          >
 <span class="description-title">
      {{ 'PRODUCT.SUBCATEGORY' | translate }}
    </span>
           

            <div
              class="category-name"
              *ngFor="
                let sub of product.subCategories;
                let last = last
              "
            >

              {{ getSubCategoryName(sub) }}

              <!-- <span *ngIf="!last">
                ,
              </span> -->

            </div>

          </ng-container>
</div>
      <!-- ===================================================
           ACTIONS
           =================================================== -->

      <div class="dialog-actions">

        <!-- ADD TO CART -->

        <button
          mat-raised-button
          type="button"
          class="add-btn"
          [disabled]="!canAddToCart"
          (click)="addToCart()"
        >

          <mat-icon>
            add_shopping_cart
          </mat-icon>

          <span>

            {{ 'PRODUCT.ADD_TO_CART' | translate }}

          </span>

        </button>


        <!-- BACK -->

        <button
          mat-raised-button
          type="button"
          class="back-btn"
          (click)="goBack()"
        >

          <mat-icon>
            arrow_back
          </mat-icon>

          <span>

            {{ 'COMMON.BACK' | translate }}

          </span>

        </button>

      </div>

    </div>

  </div>



  <!-- =====================================================
       RELATIVE PRODUCTS
       ===================================================== -->

  <app-relative-products
  *ngIf="product() as currentProduct"

  [currentProductId]="currentProduct.id"

  [subCategoryId]="
    currentProduct.subCategories[0]?.id ?? null
  "

  [addedToCartProductId]="addedToCartProductId()"

  [alreadyInCartProductId]="alreadyInCartProductId()"

  (productClicked)="
    onRelativeProductClicked($event)
  "

  (addToCartClicked)="
    onRelativeAddToCartClicked($event)
  "
>
</app-relative-products>

</div>